import { FileWithPath } from 'react-dropzone';

import { createModalStore } from '@/shared/lib/modal';

type CreateProjectModalProps = {
  files?: FileWithPath[];
  isFirstProject?: boolean;
  isSample: boolean;
  presetName?: string;
  presetRecordingId?: string;
  presetSourceUrl?: string;
  /**
   * Called on submit before `presetSourceUrl` is uploaded; resolves with the link to upload instead (e.g. a recording
   * re-rendered with its saved edits), or with null to drop the submit. A rejection is shown as an error alert.
   */
  resolvePresetSourceUrl?: () => Promise<null | string>;
};

const initialState: CreateProjectModalProps = {
  files: undefined,
  isFirstProject: false,
  isSample: false,
  presetName: undefined,
  presetRecordingId: undefined,
  presetSourceUrl: undefined,
  resolvePresetSourceUrl: undefined,
};

export const useCreateProjectModalStore = createModalStore<CreateProjectModalProps>(initialState, false);
